'use strict'

import Login from "@/router/login"
import Home from "@/router/home"
import ErrorPage from "@/router/errorPage";
import bulkPay from "@/router/bulkPay";
import individual from "@/router/individual"
import recharges from "@/router/recharges"
import invoice from "@/router/invoice"
import sign from "@/router/sign"
import missionSquare from "@/router/missionSquare"
import executives from "@/router/executives"
import previewFile from '@/router/previewFile'
import merchants from '@/router/merchants'
import Export from '@/router/export'


const appRouters = {
    path: '/app',
    name: 'app',
    meta:{
        breadcrumb:'首页',
        code:''
    },
    redirect: {
      name: 'home'
    },
    component: () => import('@/pages/layout/Layout'),
    children: [
        Home,
        bulkPay,
        individual,
        recharges,
        invoice,
        sign,
        merchants,
        missionSquare,
        executives,
        ErrorPage,
        Export
    ]
};

const domain = {
    path:'/login',
    redirect:{'name':'app-login'},
}

export const routers = [
    {
      path:'/',
      redirect:{
        name: 'app'
      },
      component: () => import('@/components/RouterView'),
      children:[
        Login,
        appRouters,
        previewFile,
        domain,
      ]
    },
    {
      path: '*',
      redirect: {
        name: 'page-404'
      }
    },
]

